import _toConsumableArray from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import uniqBy from 'lodash.uniqby';
import { ProviderLabel } from './types.js';
import standardWallets from './wallets.js';
import { remove } from './helpers.js';
import { validateWalletOptions } from './validation.js';
export { ProviderIdentityFlag, ProviderLabel } from './types.js';

function injected(options) {
  if (typeof window === 'undefined') return function () {
    return null;
  };

  if (options) {
    var result = validateWalletOptions(options);
    if (result && result.error) throw result.error;
  }

  return function (helpers) {
    var device = helpers.device;

    var _ref = options || {},
        _ref$custom = _ref.custom,
        custom = _ref$custom === void 0 ? [] : _ref$custom,
        _ref$filter = _ref.filter,
        filter = _ref$filter === void 0 ? {} : _ref$filter;

    var allWallets = [].concat(_toConsumableArray(custom), _toConsumableArray(standardWallets));
    var deduped = uniqBy(allWallets, function (_ref2) {
      var label = _ref2.label;
      return "".concat(label);
    });
    var filteredWallets = deduped.filter(function (wallet) {
      var label = wallet.label,
          platforms = wallet.platforms;
      var walletFilters = filter[label];
      var filteredWallet = walletFilters === false;
      var excludedDevice = Array.isArray(walletFilters) && (walletFilters.includes(device.type) || walletFilters.includes(device.os.name));
      var invalidPlatform = !platforms.includes('all') && !platforms.includes(device.type) && !platforms.includes(device.os.name);
      var supportedWallet = !filteredWallet && !excludedDevice && !invalidPlatform;
      return supportedWallet;
    });
    var removeMetaMask = false;
    var validWallets = filteredWallets.filter(function (_ref3) {
      var injectedNamespace = _ref3.injectedNamespace,
          checkProviderIdentity = _ref3.checkProviderIdentity,
          label = _ref3.label;
      var provider = window[injectedNamespace];
      if (!provider) return;
      var walletExists;

      if (provider.providers && Array.isArray(provider.providers)) {
        walletExists = !!provider.providers.filter(function (provider) {
          return checkProviderIdentity({
            provider: provider,
            device: device
          });
        }).length;
      } else {
        walletExists = checkProviderIdentity({
          provider: provider,
          device: device
        });
      }

      if (walletExists && provider.isMetaMask && !provider.overrideIsMetaMask && label !== ProviderLabel.MetaMask && label !== 'Detected Wallet') {
        removeMetaMask = true;
      }

      return walletExists;
    });

    if (validWallets.length) {
      var moreThanOneWallet = validWallets.length > 1; // if more than one wallet, then remove detected wallet

      return validWallets.filter(remove({
        detected: moreThanOneWallet,
        metamask: moreThanOneWallet && removeMetaMask
      })).map(function (_ref4) {
        var label = _ref4.label,
            getIcon = _ref4.getIcon,
            getInterface = _ref4.getInterface;
        return {
          label: label,
          getIcon: getIcon,
          getInterface: getInterface
        };
      });
    }

    return [];
  };
}

export default injected;